var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.periodesMetOpdrachten.length === 0
      ? _c("h3", { staticClass: "text-center col-sm-11" }, [
          _vm._v("\n    Geen opdrachten\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "periodes" },
      _vm._l(_vm.periodesMetOpdrachten, function(periodeMetOpdrachten, index) {
        return _c("PeriodeMetOpdrachtenView", {
          key: "periode-" + index,
          attrs: { periodeMetOpdrachten: periodeMetOpdrachten }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }